import React, { Component } from "react";
import * as Constants from "../../Constants/index";
import Loading from "../../Constants/Loading";
import ProgressBar from "react-bootstrap/ProgressBar";
import axios from "axios";
import "./MovieSession.css";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { FaClock, FaShareAlt } from "react-icons/fa";
import TrailerModal from "../trailer/TrailerModal.component";
import "../movie-details/MovieDetails.style.css";
import MovieInfoDetails from "../movie-info-detail/MovieInfoDetails.component";
import swal from "sweetalert";
import Text from "react-text";
import Modal from "react-modal";
import pgIcon from "../../assets/icons/pg.png";
import _pg12Icon from "../../assets/icons/6.png";
import _12PlusIcon from "../../assets/icons/numberTwell.png";
import _15PlusIcon from "../../assets/icons/numberfiftheen.png";
import _18PlusIcon from "../../assets/icons/eigthteen.png";

class MovieSession extends Component {
  state = {
    city: this.props.match.params.city,
    amcode: this.props.match.params.amcode,
    mname: this.props.match.params.moviename,
    lat: 0.0,
    lng: 0.0,
    date: "",
    lang: "ALL",
    format: "ALL",
    price: "ALL",
    time: "ALL",
    cinetype: "ALL",
    special: "ALL",
    hc: "ALL",
    output: {},
    lngs: [],
    cinemas: [],
    days: [],
    selectedDate: "",
    selectedDay: "",
    showTrailer: false,
    showCertPopup: false,
    popupData: null,
    loading: 0,
    certData: "",
    selectedShowData: null,
  };

  componentDidMount() {
    Modal.setAppElement('#root');
    let formDataNS = new FormData();
    formDataNS.append("city", localStorage.getItem("selectedcity"));
    formDataNS.append("mid", this.state.amcode);
    formDataNS.append("lat", this.state.lat);
    formDataNS.append("lng", this.state.lng);
    formDataNS.append("date", this.state.date);
    formDataNS.append("userid", 0);
    formDataNS.append("lang", this.state.lang);
    formDataNS.append("format", this.state.format);
    formDataNS.append("price", this.state.price);
    formDataNS.append("time", this.state.time);
    formDataNS.append("cinetype", this.state.cinetype);
    formDataNS.append("av", Constants.av);
    formDataNS.append("pt", Constants.pt);
    formDataNS.append("did", Constants.did);

    const movieSessionRequest = async () => {
      try {
        this.setState({ loading: 1 });
        await axios
          .post(Constants.api + "content/msessionsfilters?_t=" + Date.now(), formDataNS, {
            headers: {
              "Accept-Language": localStorage.getItem("language"),
              "Cache-Control": "no-cache, no-store, must-revalidate",
              Pragma: "no-cache",
            },
          })
          .then((resp) => {
            if (resp.data.result === "success") {
              this.setState({ loading: 0 });
              console.log(resp.data.output);
              this.setState({ output: resp.data.output });
              this.setState({ certData: resp.data.output.cert });
              console.log(" resp.data.output lngs ", resp.data.output);

              let lngsArray = [];
              Object.keys(resp.data.output.lngs).forEach(function (key) {
                lngsArray.push(resp.data.output.lngs[key]);
              });

              let daysArray = [];
              Object.keys(resp.data.output.dys).forEach(function (key) {
                daysArray.push(resp.data.output.dys[key]);
              });

              let sDay = "";
              let sD = "";
              Object.keys(daysArray).forEach(function (item, index) {
                if (index == 0) {
                  console.log(daysArray[index].wd);
                  sDay = daysArray[index].wd;
                  sD = daysArray[index].d;
                  return;
                }
              });

              let cinemasArray = [];
              Object.keys(resp.data.output.cinemas).forEach(function (key) {
                cinemasArray.push(resp.data.output.cinemas[key]);
              });

              this.setState({
                lngs: lngsArray,
                cinemas: cinemasArray,
                days: daysArray,
                selectedDay: sDay,
                selectedDate: sD,
              });
            } else {
              console.log(resp.data.msg);
              alert(resp.data.msg);
              this.setState({ loading: 0 });
            }
          });
      } catch (err) {
        console.error(err);
      }
    };
    movieSessionRequest();
  }

  closeModal = () => {
    this.setState({ 
      showCertPopup: false, 
      selectedShowData: null 
    });
  };

  handleAgree = () => {
    const { selectedShowData } = this.state;
    
    if (selectedShowData) {
      // Create the URL using the stored show data
      const seatLayoutUrl = 
        "/seatlayout/" +
        selectedShowData.cinemaName
          .toString()
          .toLowerCase()
          .replaceAll(" ", "-") +
        "/movie?mcode=" +
        selectedShowData.movieCode +
        "&sessionid=" +
        selectedShowData.sessionId +
        "&cinemacode=" +
        selectedShowData.cinemaCode;
      
      // Close the modal
      this.setState({ 
        showCertPopup: false, 
        selectedShowData: null 
      });
      
      // Redirect to seat layout
      window.location.href = seatLayoutUrl;
    }
  };

  handleShowClick = (mcinema, show, cinema) => {
    // Store the show data
    const showData = {
      cinemaName: mcinema.cn,
      movieCode: show.mc,
      sessionId: show.sid,
      cinemaCode: cinema.ccid,
      showTime: show.st
    };
    
    // Check if cert is empty
    if (!this.state.certData || this.state.certData === "") {
      // If no certificate, directly redirect to seat layout
      const seatLayoutUrl = 
        "/seatlayout/" +
        mcinema.cn
          .toString()
          .toLowerCase()
          .replaceAll(" ", "-") +
        "/movie?mcode=" +
        show.mc +
        "&sessionid=" +
        show.sid +
        "&cinemacode=" +
        cinema.ccid;
      
      window.location.href = seatLayoutUrl;
    } else {
      // If there is a certificate, show the popup
      this.setState({
        showCertPopup: true,
        selectedShowData: showData
      });
    }
  };

  render() {
    const selectDate = (dateSelected, daySelected, ddSelected) => {
      let formDataDS = new FormData();
      formDataDS.append("mid", this.state.amcode);
      formDataDS.append("lat", this.state.lat);
      formDataDS.append("lng", this.state.lng);
      formDataDS.append("date", dateSelected);
      formDataDS.append("userid", 0);
      formDataDS.append("lang", this.state.lang);
      formDataDS.append("format", this.state.format);
      formDataDS.append("price", this.state.price);
      formDataDS.append("time", this.state.time);
      formDataDS.append("cinetype", this.state.cinetype);
      formDataDS.append("av", Constants.av);
      formDataDS.append("pt", Constants.pt);
      formDataDS.append("did", Constants.did);

      try {
        this.setState({ loading: 1 });
        axios
          .post(Constants.api + "content/msessionsfilters/?_t=" + Date.now(), formDataDS, {
            headers: {
              "Accept-Language": localStorage.getItem("language"),
              "Cache-Control": "no-cache, no-store, must-revalidate",
              Pragma: "no-cache",
            },
          })
          .then((resp) => {
            if (resp.data.result === "success") {
              this.setState({ loading: 0 });
              console.log(resp.data.output);

              let cinemasArray = [];
              Object.keys(resp.data.output.cinemas).forEach(function (key) {
                cinemasArray.push(resp.data.output.cinemas[key]);
              });

              this.setState({
                cinemas: cinemasArray,
                selectedDay: daySelected,
                selectedDate: ddSelected,
              });

              var element = document.getElementById("otherDateFilter");
              if (element) element.classList.remove("active");
            } else {
              console.log(resp.data.msg);
              alert(resp.data.msg);
              this.setState({ loading: 0 });
            }
          });
      } catch (err) {
        console.error(err);
      }
    };

    var seld = this.state.selectedDate;

    const daysRender2 = this.state.days
      .filter((item, idx) => idx < 7)
      .map((item, i) => {
        // Use unique ID for each button
        const uniqueId = `dateFilter-${i}`;
        const isActive = seld == item.d;
        const btnClass = isActive ? "btn btn-week active" : "btn btn-week";

        return (
          <button
            key={i}
            className={btnClass}
            id={uniqueId}
            onClick={() => selectDate(item.dt, item.wd, item.d)}
          >
            {item.wd} <br />
            {item.d}
          </button>
        );
      });

    const outputs = this.state.output;

    const MovieDetails = ({ nm, len, gnr, lng, lngs, mih, miv, vdo, cert }) => {
      return (
        <div className="movie-details container mobile-container">
          <div className="booking-poster">
            <img src={miv} alt="img" />
          </div>
          <div className="booking-movie-details">
            <h3>{nm}</h3>
            <p>
              {len ? <FaClock /> : ""} {len} | {lng} | {cert} | {gnr}
            </p>
            {vdo != "" ? (
              <div>
                <button
                  className="btn btn-normal btn-watch-trailer"
                  onClick={() => this.setState({ showTrailer: true })}
                >
                  <a href="#">
                    {localStorage.getItem("language") != "ar" ? (
                      "Watch Trailer"
                    ) : (
                      <Text>مشاهدة اعلان</Text>
                    )}
                  </a>
                </button>
                <FaShareAlt className="share hidden" />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      );
    };

    const cinemaRender = this.state.cinemas.map((mcinema, i) => {
      return (
        <div className="cinema-holder" key={i}>
          <div className="cinema-title">
            <h4 className="title">{mcinema.cn}</h4>
          </div>
          {mcinema.childs.map((cinema, j) => {
            return (
              <div key={j}>
                {cinema.sws.map((sws, k) => {
                  return (
                    <ul className="type-time-slots" key={k}>
                      {sws.s.map((show, l) => {
                        let showClass = "slot ";
                        if (show.ss == 1) {
                          showClass += "text-success";
                        } else if (show.ss == 2) {
                          showClass += "text-warning";
                        } else if (show.ss == 3) {
                          showClass += "text-danger";
                        } else {
                          showClass += "text-default";
                        }
                        let availableBar =
                          ((show.ts - show.as) / show.ts) * 100;

                        return (
                          <li key={l}>
                            <p className="cin-type">{cinema.ccn}</p>
                            <p className="lang-time">{sws.lng}</p>
                            <div className="timing-box">
                              {show.ss == 0 || show.ss == 3 ? (
                                <a disabled="disabled" className={showClass}>
                                  {show.st}
                                </a>
                              ) : (
                                <a
                                  href="#"
                                  className={showClass}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.handleShowClick(mcinema, show, cinema);
                                  }}
                                >
                                  {show.st}
                                </a>
                              )}
                              <ProgressBar
                                now={availableBar}
                                className="seats-bar"
                              />
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  );
                })}
              </div>
            );
          })}
        </div>
      );
    });

    return (
      <>
        {this.state.showTrailer && (
          <Modal
            isOpen={this.state.showTrailer}
            contentLabel="Trailer Modal"
            portalClassName="trai-modal"
          >
            <button
              className="trailer-cross"
              onClick={() => this.setState({ showTrailer: false })}
              aria-label="Close trailer"
            >
              <i className="fas fa-times"></i>
            </button>
            <TrailerModal trailerUrl={this.state.output.vdo} />
          </Modal>
        )}

        <div className="booking">
          <div
            className="booking-upper"
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%), url(${this.state.output.mih})`,
            }}
          >
            {<MovieDetails {...outputs} />}
            <div className="current-week">
              <div className="cureent-container container">
                <div className="display-week">
                  <div className="filling-data">{daysRender2}</div>
                  <div className="filling-details">
                    <p>
                      {localStorage.getItem("language") != "ar"
                        ? "AVAILABLE"
                        : "متوفرة"}
                    </p>
                    <p>
                      {localStorage.getItem("language") != "ar"
                        ? "FILLING FAST"
                        : "ملء سريع"}
                    </p>
                    <p>
                      {localStorage.getItem("language") != "ar"
                        ? "SOLD OUT"
                        : "نفذ"}
                    </p>
                    <p>
                      {localStorage.getItem("language") != "ar"
                        ? "LAPSED"
                        : "انقضت"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="booking-lower hidden-mobile">
            <div className="bookin-lower-contain container hidden-mobile">
              <div className="movie-info hidden-mobile">
                <h4>
                  {localStorage.getItem("language") != "ar"
                    ? "movie info"
                    : "معلومات الفيلم"}
                </h4>
                {<MovieInfoDetails {...outputs} />}
              </div>

              {this.state.loading == 1 ? (
                <Loading />
              ) : (
                <div className="showtimes">
                  <Tabs defaultActiveKey="showtimes">
                    <Tab
                      eventKey="showtimes"
                      title={
                        localStorage.getItem("language") != "ar"
                          ? "showtimes"
                          : "أوقات العرض"
                      }
                      tabClassName="booking-time"
                    >
                      {cinemaRender}
                    </Tab>
                    <Tab
                      eventKey="synopsis"
                      title={
                        localStorage.getItem("language") != "ar"
                          ? "Synopsis"
                          : "ملخص"
                      }
                      tabClassName="booking-time"
                    >
                      <p>{this.state.output.p}</p>
                    </Tab>

                    <Tab
                      eventKey="Movie-info"
                      title={
                        localStorage.getItem("language") != "ar"
                          ? "Movie-info"
                          : "معلومات"
                      }
                      tabClassName="booking-time"
                    >
                      <div className="bookin-lower-contain container booking-mobile">
                        <div className="movie-infos booking-mobile">
                          <h4>
                            {localStorage.getItem("language") != "ar"
                              ? ""
                              : "معلومات الفيلم"}
                          </h4>
                          {<MovieInfoDetails {...outputs} />}
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Certificate Popup Modal */}
        <Modal
          isOpen={this.state.showCertPopup}
          contentLabel="Certificate Information Modal"
          portalClassName="cert-modal"
          onRequestClose={this.closeModal}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.40)",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
            content: {
              position: "relative",
              top: "auto",
              left: "auto",
              right: "auto",
              bottom: "auto",
              margin: "0 auto",
              background: "000",
              width: "500px",
              maxWidth: "90%",
              padding: "20px",
              borderRadius: "8px",
              border: "none",
              overflow: "auto",
              height: "auto",
            },
          }}
        >
          {/* <button
            className="cert-cross"
            onClick={this.closeModal}
            aria-label="Close modal"
            style={{
              position: "absolute",
              top: "21px",
              right: "33px",
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              color: "#666",
            }}
          >
            <i className="fas fa-times"></i>
          </button> */}
          <div className="cert-popup-content">
            <h3 style={{ marginTop: 0, marginBottom: "15px", fontWeight: "bold" }}>
              {localStorage.getItem("language") != "ar"
                ? "Conditions of access to the cinema"
                : "معلومات الشهادة"}
            </h3>
            {this.state.certData === "PG 12" && (
              <img src={_pg12Icon} alt="" style={{ width: "60px" }} />
            )}
            {this.state.certData === "15+" && (
              <img src={_15PlusIcon} alt="" style={{ width: "60px" }} />
            )}
            {this.state.certData === "12+" && (
              <img src={_12PlusIcon} alt="" style={{ width: "60px" }} />
            )}
            {this.state.certData === "18+" && (
              <img src={_18PlusIcon} alt="" style={{ width: "60px" }} />
            )}
            {this.state.certData === "PG" && (
              <img src={pgIcon} alt="" style={{ width: "60px" }} />
            )}

            <p style={{ margin: 0 }}>
              {(() => {
                if (this.state.certData === "PG 12") {
                  return localStorage.getItem("language") !== "ar"
                    ? "I understand this movie is rated PG12. No person under the age listed above will be permitted without an adult. I accept that our entry to the cinemas will also be in adherence with the same government guidelines provided to the mall."
                    : "أفهم أن هذا الفيلم مصنف PG12. لا يُسمح لأي شخص دون السن المذكور أعلاه بالدخول دون مرافقة شخص بالغ. أقبل أن دخولنا إلى دور السينما سيكون أيضًا متوافقًا مع نفس الإرشادات الحكومية المقدمة للمول.";
                }
                if (this.state.certData === "15+") {
                  return localStorage.getItem("language") !== "ar"
                    ? "I understand this movie is rated 15+. No person under 15 years of age will be permitted. I accept that our entry to the cinemas will also be in adherence with the same government guidelines provided to the mall."
                    : "أفهم أن هذا الفيلم مصنف 15+. لا يُسمح لأي شخص دون 15 سنة بالدخول. أقبل أن دخولنا إلى دور السينما سيكون أيضًا متوافقًا مع نفس الإرشادات الحكومية المقدمة للمول.";
                }
                if (this.state.certData === "12+") {
                  return localStorage.getItem("language") !== "ar"
                    ? "I understand this movie is rated 12+. No person under 12 years of age will be permitted. I accept that our entry to the cinemas will also be in adherence with the same government guidelines provided to the mall."
                    : "أفهم أن هذا الفيلم مصنف 12+. لا يُسمح لأي شخص دون 12 سنة بالدخول. أقبل أن دخولنا إلى دور السينما سيكون أيضًا متوافقًا مع نفس الإرشادات الحكومية المقدمة للمول.";
                }
                if (this.state.certData === "18+") {
                  return localStorage.getItem("language") !== "ar"
                    ? "I understand this movie is rated 18+. No person under 18 years of age will be permitted. I accept that our entry to the cinemas will also be in adherence with the same government guidelines provided to the mall."
                    : "أفهم أن هذا الفيلم مصنف 18+. لا يُسمح لأي شخص دون 18 سنة بالدخول. أقبل أن دخولنا إلى دور السينما سيكون أيضًا متوافقًا مع نفس الإرشادات الحكومية المقدمة للمول.";
                }
                if (this.state.certData === "PG") {
                  return localStorage.getItem("language") !== "ar"
                    ? "I understand this movie is PG. This movie is suitable for all ages, but adult supervision is recommended. I accept that our entry to the cinemas will also be in adherence with the same government guidelines provided to the mall."
                    : "أفهم أن هذا الفيلم مصنف PG. هذا الفيلم مناسب لجميع الأعمار، ولكن يُنصح بالإشراف من شخص بالغ. أقبل أن دخولنا إلى دور السينما سيكون أيضًا متوافقًا مع نفس الإرشادات الحكومية المقدمة للمول.";
                }
                return "";
              })()}
            </p>
            <div>
              <br />
              <button className="btn btn-normal cert-close-btn" onClick={this.handleAgree}>
                Agree
              </button>
              <button
                className="btn btn-normal cert-close-btn"
                onClick={this.closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default MovieSession;